﻿/**
 * DefaultTabItem — one of the two system tabs ("All shipments" / "Active").
 * Cannot be edited, hidden, or deleted.
 */

import React from 'react';
import { Badge, Typography } from 'antd';
import type { DefaultTab } from '@/pages/Shipments/ControlTower/types';
import styles from './TabStrip.module.scss';

const { Text } = Typography;

interface Props {
  tab: DefaultTab;
  isActive: boolean;
  shipmentCount?: number;
  onClick: () => void;
}

const DefaultTabItem: React.FC<Props> = ({
  tab,
  isActive,
  shipmentCount,
  onClick,
}) => {
  return (
    <div
      data-testid={`default-tab-${tab.id}`}
      role='tab'
      aria-selected={isActive}
      onClick={onClick}
      className={`${styles.tabItem} ${isActive ? styles.tabItemDefaultActive : ''}`}
    >
      <Text className={styles.tabItemTextEllipsis}>{tab.label}</Text>
      {shipmentCount !== undefined && (
        <span
          className={`${styles.badgeWrapper} ${styles.badgeRounded}  ${isActive ? styles.badgeActive : styles.badgeInactive}`}
        >
          <Badge count={shipmentCount} overflowCount={9999} />
        </span>
      )}
    </div>
  );
};

export default DefaultTabItem;
